function ensure<T>(obj?: T): Partial<T> {
  return obj ?? ({} as Partial<T>);
}

function shakeOffUndefined(obj: any) {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== undefined));
}

export const ObjectFuncs = {
  ensure,
  shakeOffUndefined,
};
